var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',_vm._g(_vm._b({staticClass:"dis-b w-100p",model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'el-select',_vm.$attrs,false),_vm.$listeners),_vm._l((_vm.data),function(itme){return _c('el-option',{key:itme.id,attrs:{"label":itme.dictValue,"value":itme.dictKey}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }